var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedHeartIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    d: "M22.573,3.752a6.65,6.65,0,0,0-9.111.668l-.962,1-.962-1a6.65,6.65,0,0,0-9.111-.668,7.079,7.079,0,0,0-.483,10.209l9.448,9.811a1.525,1.525,0,0,0,2.212,0l9.448-9.811a7.074,7.074,0,0,0-.479-10.209Z",
    transform: "translate(0.001 -2.248)",
    fill: "#ed1a2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeartIconFilled);
export default __webpack_public_path__ + "static/media/red-heart-icon-filled.8c765cb53fc91cba4ec5d6cdfed1fb4b.svg";
export { ForwardRef as ReactComponent };